import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { StyledTopBarContainer, StyledSelect, StyledOption, StyledStyledSortTitle, StyledStyledTitle, StyledTopBarWrapper } from './TopBar.styled';
import ListStyleImage from "../../../assets/images/list_style.png"
import Button from '../../Button/Button';

interface Props {
    fullView: boolean
    setFilter: (value: string) => void
    setFilterDate: (value: string) => void
}

const TopBar = (props: Props) => {
    const navigate = useNavigate();

    const handleClickFullView = () => {
        navigate('/leaderboard'); // Navigate to the 'About' page
    };

    return (
        <StyledTopBarContainer>
            <StyledTopBarWrapper>
                <StyledStyledTitle>Leaderboard</StyledStyledTitle>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <StyledStyledSortTitle>Sort by: </StyledStyledSortTitle>
                    <StyledSelect onChange={(e) => props.setFilter(e.target.value)}>
                        <StyledOption value={"tokens_won"}>Tokens Won</StyledOption>
                        <StyledOption value={"hands_won"}>Hands Won</StyledOption>
                        <StyledOption value={"hands_played"}>Hands Played</StyledOption>
                    </StyledSelect>
                    <StyledSelect onChange={(e) => props.setFilterDate(e.target.value)}>
                        <StyledOption value={"24"}>Past 24 Hours</StyledOption>
                        <StyledOption value={"all"}>All</StyledOption>
                    </StyledSelect>
                </div>
            </StyledTopBarWrapper>
            {
                !props.fullView && (
                    <Button padding='1rem' text='Full View' size='small' textSize='12px' image={ListStyleImage} event={handleClickFullView} />
                )
            }
        </StyledTopBarContainer>
    );
}

export default TopBar;
